var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSoundcloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24.000000pt",
    height: "24.000000pt",
    viewBox: "0 0 24.000000 24.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,24.000000) scale(0.100000,-0.100000)",
    fill: "#fff",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M137 183 c-2 -5 -3 -17 -2 -28 1 -11 2 -35 3 -53 2 -32 3 -33 39 -30 28 2 39 8 42 22 2 11 -3 24 -11 30 -8 6 -17 19 -21 28 -7 19 -44 42 -50 31z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109 173 c-7 -38 -5 -94 2 -99 5 -3 9 20 9 50 0 31 -2 56 -5 56 -3 0 -6 -3 -6 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79 153 c0 -5 -2 -18 -5 -31 -2 -13 0 -31 6 -40 7 -13 9 -5 10 31 0 26 -2 47 -5 47 -3 0 -5 -3 -6 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46 122 c-6 -10 -2 -39 7 -48 4 -4 7 7 7 24 0 32 -4 39 -14 24z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 109 c-3 -6 -1 -16 5 -22 8 -8 11 -5 11 11 0 24 -5 28 -16 11z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoundcloud);
export default __webpack_public_path__ + "static/media/soundcloud.f4519bbd.svg";
export { ForwardRef as ReactComponent };